
  <div [matTooltip]="getTooltip()" matTooltipPosition="right">
  <button matIconButton class="mat-icon-toggle-button" [disabled]="disable" type="button" [class.selected]="active" (click)="toggleSwipe()" *ngIf="(flagService.getFlags$() | async)?.[FeatureFlags.BEFORE_AFTER] && !discreteEnabled">
    <mat-icon>flip</mat-icon>
  </button>
</div>
